import React, { Component } from 'react';

import FourZeroFour from '../fourzerofour';
import PDHeader1 from './PDHeader1';
import PDHeader2 from './PDHeader2';
import PDDetail from './PDDetail';

class OfficeFurnitureRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = { product_details: "loading" };
        this.getProductDetail();
    }

    getProductDetail() {

    }

    render() {
        const data = this.state.product_details;
        if (data) {
            if (data.LayoutFlag === 1)
                return (
                    <div id="productDetails">
                        <PDHeader1 item={data} />
                        <PDDetail item={data} />
                    </div>
                )
            else
                return (
                    <div id="productDetails">
                        <PDHeader2 item={data} />
                        <PDDetail item={data} />
                    </div>
                )
        }
        else
            return (
                <FourZeroFour />
            )
    }
}

export default OfficeFurnitureRenderer;